<div class="draggable-templates-container">
  <div class="inner">
    <div class="content">
      <div class="top">
        <div class="title">
          {{ 'CALENDAR.LEGEND.TITLE' | translate }}
        </div>
        <div class="subtitle">
          <span [innerHTML]="'CALENDAR.LEGEND.TITLE' | translate"></span>
        </div>
      </div>
      <div class="template-container">
        <div *ngFor="let customer of customers" class="template">
          <app-calendar-legend-customer [customer]="customer" (click)="selectCustomer(customer)"> </app-calendar-legend-customer>
        </div>
      </div>
    </div>

    <div class="hr"></div>
  </div>
</div>
